import {TECH_DRIVE_REFS} from './constants';

// Helper function to safely parse query parameters
export const parseQueryParam = (key: string): string | null => {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

export const checkIsTechDrive = (): boolean => {
  const ref = parseQueryParam('ref');

  return TECH_DRIVE_REFS.includes(ref ?? '');
};
